<template>
  <div id="app">
    <!-- <h1>Hello App!</h1> -->
    <!-- <p> -->
      <!-- 使用 router-link 组件来导航. -->
      <!-- 通过传入 `to` 属性指定链接. -->
      <!-- <router-link> 默认会被渲染成一个 `<a>` 标签 -->
      <!-- <router-link to="/foo">Go to Foo</router-link> -->
      <!-- <router-link to="/bar">Go to Bar</router-link> -->
    <!-- </p> -->
    <!-- 路由出口 -->
    <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  components: {
  }
};
</script>

<style>
/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "阿里巴巴普惠体 2.0 55 Regular";
  font-weight: 400;
  src: url("//at.alicdn.com/wf/webfont/IoekGff1B5Xm/Ln3LBmgYHrbm.woff2")
      format("woff2"),
    url("//at.alicdn.com/wf/webfont/IoekGff1B5Xm/7VPxxrCPubOG.woff")
      format("woff");
  font-display: swap;
}

/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "思源黑体 Light";
  font-weight: 300;
  src: url("//at.alicdn.com/wf/webfont/IoekGff1B5Xm/F3efGJTOfOau.woff2")
      format("woff2"),
    url("//at.alicdn.com/wf/webfont/IoekGff1B5Xm/eBFbiIrG0G1m.woff")
      format("woff");
  font-display: swap;
}

/* 在线链接服务仅供平台体验和调试使用，平台不承诺服务的稳定性，企业客户需下载字体包自行发布使用并做好备份。 */
@font-face {
  font-family: "思源宋体 Light";
  font-weight: 300;
  src: url("//at.alicdn.com/wf/webfont/IoekGff1B5Xm/Apd7XexgZ7Uq.woff2")
      format("woff2"),
    url("//at.alicdn.com/wf/webfont/IoekGff1B5Xm/bxyvg9dNB3Dj.woff")
      format("woff");
  font-display: swap;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  font-family: "阿里巴巴普惠体 2.0 55 Regular", "思源黑体 Light",
    "思源宋体 Light";
}

ul li {
  list-style: none;
}
</style>
